import React from 'react';
import { Route } from 'react-router-dom';
import OnboardingGate from './OnboardingGate';
import WelcomePage from './WelcomePage';
import TonePage from './TonePage';
import PreviewPage from './PreviewPage';
import ConnectPage from './ConnectPage';

export const onboardingRoutes = (
  <Route path="/onboarding" element={<OnboardingGate />}>
    <Route index element={<WelcomePage />} />
    <Route path="tone" element={<TonePage />} />
    <Route path="preview" element={<PreviewPage />} />
    <Route path="connect" element={<ConnectPage />} />
  </Route>
);
